module.exports = __webpack_public_path__ + "static/media/farmermath.30746975.png";